(function(){
    'use strict'

    angular
    .module('app.unidades')
    .controller('Unidades', Unidades);

    Unidades.$inject = ['$animationsSrv', 'UnidadesService', 'logger', '$location', 'UserInfoService'];

    function Unidades($animationsSrv, UnidadesService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.unidades = [];
        vm.title = 'Unidades';

        vm.goToEdit = function(unidad){
            
            var path = '/editar-unidad/';

            if(unidad){
                $location.path(path + unidad.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = UnidadesService.getAll();

            promise
            .then(function(unidades){
                vm.unidades = unidades;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las unidades.');
                        break;
                }
            });
        };

        vm.delete = function(unidad){
            var promise = UnidadesService.remove(unidad);
            
            promise
            .then(function(response){
                vm.unidades = vm.unidades.filter(function(g) {
                    return g.id !== unidad.id;
                });
                logger.success('Unidad eliminada con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar La unidad');
                        break;
                }
                
            });   
        };

    }
})();